// import * as types from './mutation-types'
// import { getTest } from "../services"
//
// export const getData = function ({commit, state}, {list, index}) {
//   commit(types.SET_TIP_INFOR, {tipFlag: false, tipMsg: ''})
// }
//
// export const actionTest = function ({commit, state}, data) {
//   getTest({
//     url: 'getPhoneCode.php',
//     data: JSON.stringify({
//       'phone': '1111'
//     })
//   })
//     .then(response => {
//       console.log(response.data)
//       commit(types.SET_ALERT_DETAIL, {title: '提示', content: '您确定删除该记录吗？'})
//       commit(types.SET_ALERT_FLAG, {state: true, type: ''})
//     })
// }

import http from "../config/axios";
import apiSetting from "../config/apiSetting";
export const getCartCount = function ({commit, state}, data) {
  let requestData = {
    sortConditions: '',
    whereConditions: []
  }
  requestData.whereConditions = [];
// _this.$store.state.account.entityId
  requestData.whereConditions.push({
    'EQUAL': {
      'field': 'fownOrgId',
      'fieldValue': this.$store.state.account.entityId,
      'required': 'Y',
      'dataType': 'Long'
    }
  });
  http(apiSetting.cartList, {data: JSON.stringify(requestData)}).then(
    res => {
      if (res && res.resultType === 'Success') {
        console.log(JSON.parse(res.resultJsonStr))
        let cartList = JSON.parse(res.resultJsonStr).listElements
        commit(SET_CARTCOUNT, cartList.length)
      }
    })
}
//
export default {
  getCartCount
}
